import React from 'react';
export const WaitingId = () => (
  <svg width="139px" height="113px" viewBox="0 0 139 113" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1325.000000, -1891.000000)">
        <g transform="translate(1325.000000, 1891.000000)">
          <path
            d="M84.5874,10.7504 L80.4004,10.6934"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M90.2324,4.5502 L90.2894,0.3632"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M86.1626,6.0453 L83.1816,2.9033"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M37.647,109.2983 L18.891,109.2983"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.8906,109.2983 L0.8546,109.2983"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.3052,109.0346 C82.3052,111.1196 74.9412,112.8086 65.8562,112.8086 C56.7722,112.8086 49.4082,111.1196 49.4082,109.0346 C49.4082,106.9496 56.7722,105.2606 65.8562,105.2606 C74.9412,105.2606 82.3052,106.9496 82.3052,109.0346"
            fill="#D0D7DA"
          />
          <path
            d="M80.7798,66.6791 L29.9718,73.5601 C27.8358,73.8501 25.8698,72.3531 25.5808,70.2171 L21.4828,39.9591 C21.1938,37.8241 22.6908,35.8581 24.8258,35.5681 L75.6338,28.6871 C77.7698,28.3981 79.7358,29.8951 80.0248,32.0311 L84.1228,62.2881 C84.4118,64.4241 82.9158,66.3901 80.7798,66.6791"
            fill="#FFFFFF"
          />
          <g transform="translate(21.000000, 33.710000)">
            <path
              d="M16.7852,0.1127 L2.3982,2.0607 C1.0512,2.2437 0.1072,3.4827 0.2892,4.8307 L4.7742,37.9437 C4.9562,39.2917 6.1972,40.2357 7.5442,40.0527 L18.6742,38.5457 L23.9862,37.8257 L61.2072,32.7847 C62.5552,32.6027 63.4992,31.3627 63.3162,30.0147 L62.9662,27.4297"
              fill="#FFFFFF"
            />
            <path
              d="M16.7852,0.1127 L2.3982,2.0607 C1.0512,2.2437 0.1072,3.4827 0.2892,4.8307 L4.7742,37.9437 C4.9562,39.2917 6.1972,40.2357 7.5442,40.0527 L18.6742,38.5457 L23.9862,37.8257 L61.2072,32.7847 C62.5552,32.6027 63.4992,31.3627 63.3162,30.0147 L62.9662,27.4297"
              stroke="#C3D3D8"
              strokeWidth="1.001"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(21.000000, 33.710000)">
            <polyline
              fill="#F3F4F6"
              points="9.0898 13.3578 1.5818 14.3748 0.7848 8.4898 59.3268 0.5608 60.1238 6.4458 12.2598 12.9278"
            />
            <polyline
              stroke="#DDE3E2"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="9.0898 13.3578 1.5818 14.3748 0.7848 8.4898 59.3268 0.5608 60.1238 6.4458 12.2598 12.9278"
            />
          </g>
          <g transform="translate(40.000000, 47.710000)">
            <path d="M0.6616,3.6703 L23.3826,0.5933" fill="#DDE3E2" />
            <path
              d="M0.6616,3.6703 L23.3826,0.5933"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 51.710000)">
            <path d="M0.5903,1.5756 L11.8943,0.0446" fill="#DDE3E2" />
            <path
              d="M0.5903,1.5756 L11.8943,0.0446"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(40.000000, 50.710000)">
            <path d="M0.6123,3.4652 L23.7713,0.3282" fill="#DDE3E2" />
            <path
              d="M0.6123,3.4652 L23.7713,0.3282"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 53.710000)">
            <path d="M0.9795,2.3109 L11.8865,0.8339" fill="#DDE3E2" />
            <path
              d="M0.9795,2.3109 L11.8865,0.8339"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M92.3174,60.8803 L43.6474,60.8803 C40.7734,60.8803 38.4434,58.5513 38.4434,55.6773 L38.4434,27.7443 C38.4434,24.8713 40.7734,22.5413 43.6474,22.5413 L92.3174,22.5413 C95.1914,22.5413 97.5204,24.8713 97.5204,27.7443 L97.5204,55.6773 C97.5204,58.5513 95.1914,60.8803 92.3174,60.8803"
            fill="#F3F4F6"
          />
          <path
            d="M96.0796,57.5844 L44.8086,57.5844 C42.6526,57.5844 40.9056,55.8374 40.9056,53.6824 L40.9056,23.1474 C40.9056,20.9924 42.6526,19.2454 44.8086,19.2454 L96.0796,19.2454 C98.2346,19.2454 99.9826,20.9924 99.9826,23.1474 L99.9826,53.6824 C99.9826,55.8374 98.2346,57.5844 96.0796,57.5844"
            fill="#FFFFFF"
          />
          <path
            d="M99.9824,42.0024 L99.9824,47.4554 L99.9824,55.1224 C99.9824,56.4824 98.8804,57.5844 97.5204,57.5844 L43.3674,57.5844 C42.0074,57.5844 40.9054,56.4824 40.9054,55.1224 L40.9054,21.7074 C40.9054,20.3474 42.0074,19.2454 43.3674,19.2454 L77.9144,19.2454 L83.1064,19.2454"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.7466,43.7992 L55.9516,43.7992"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M60.0542,43.7992 L68.2592,43.7992"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M72.3618,43.7992 L80.5668,43.7992"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M84.6694,43.7992 L92.8744,43.7992"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M47.7466,48.7221 L54.7216,48.7221"
            stroke="#C3D3D8"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M55.5571,39.2787 L48.5511,39.2787 C48.1071,39.2787 47.7461,38.9187 47.7461,38.4737 L47.7461,31.4677 C47.7461,31.0237 48.1071,30.6637 48.5511,30.6637 L55.5571,30.6637 C56.0011,30.6637 56.3621,31.0237 56.3621,31.4677 L56.3621,38.4737 C56.3621,38.9187 56.0011,39.2787 55.5571,39.2787"
            fill="#FEFCDD"
          />
          <path
            d="M55.5571,39.2787 L48.5511,39.2787 C48.1071,39.2787 47.7461,38.9187 47.7461,38.4737 L47.7461,31.4677 C47.7461,31.0237 48.1071,30.6637 48.5511,30.6637 L55.5571,30.6637 C56.0011,30.6637 56.3621,31.0237 56.3621,31.4677 L56.3621,38.4737 C56.3621,38.9187 56.0011,39.2787 55.5571,39.2787 Z"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <path
            d="M47.7466,34.9711 L56.3616,34.9711"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="51.126 37.1342 50.045 36.0542 50.045 33.8892 51.126 32.8092 52.982 32.8092 54.064 33.8892 54.064 36.0542 52.982 37.1342"
          />
          <path
            d="M53.1382,32.433 L50.9712,32.433 C50.4622,32.941 50.1782,33.226 49.6702,33.734 L49.6702,36.209 C50.1782,36.717 50.4622,37.001 50.9712,37.51 L53.1382,37.51 C53.6462,37.001 53.9302,36.717 54.4392,36.209 L54.4392,33.734 C53.9302,33.226 53.6462,32.941 53.1382,32.433 M52.8272,33.184 L53.4092,33.766 L53.6882,34.044 L53.6882,35.898 L53.4072,36.179 L52.8272,36.759 L51.2822,36.759 L51.0572,36.535 L50.4212,35.898 L50.4212,34.044 L51.0292,33.436 L51.2822,33.184 L52.8272,33.184"
            fill="#F5C400"
          />
          <path
            d="M138.0576,109.4955 L93.2676,109.4955"
            stroke="#EB1D26"
            strokeWidth="1.001"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="89.3452 54.3383 97.0482 54.3383 97.0482 50.3313"
          />
          <path
            d="M83.9165,54.3383 L86.7725,54.3383"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M27.3574,9.1078 L27.3574,11.0588"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M27.3574,14.9613 L27.3574,16.9123"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M31.2598,13.0102 L29.3088,13.0102"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M25.4063,13.0102 L23.4543,13.0102"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M38.5454,4.7787 C38.5454,5.5957 37.8824,6.2587 37.0654,6.2587 C36.2474,6.2587 35.5844,5.5957 35.5844,4.7787 C35.5844,3.9607 36.2474,3.2977 37.0654,3.2977 C37.8824,3.2977 38.5454,3.9607 38.5454,4.7787"
            fill="#D62793"
          />
          <path
            d="M116.9976,46.3217 C116.9976,47.1397 116.3346,47.8027 115.5166,47.8027 C114.6986,47.8027 114.0356,47.1397 114.0356,46.3217 C114.0356,45.5047 114.6986,44.8417 115.5166,44.8417 C116.3346,44.8417 116.9976,45.5047 116.9976,46.3217"
            fill="#F5C400"
          />
          <path
            d="M90.9292,15.3715 C90.4982,15.6965 90.0842,16.0535 89.6912,16.4455 C89.2992,16.8385 88.9432,17.2535 88.6172,17.6845 C85.1462,22.2805 85.5022,28.8485 89.6912,33.0375 C93.8812,37.2265 100.4492,37.5835 105.0452,34.1115 C105.4762,33.7865 105.8912,33.4305 106.2832,33.0375 C106.6762,32.6445 107.0322,32.2305 107.3572,31.8005 C110.8282,27.2025 110.4722,20.6355 106.2832,16.4455 C102.0942,12.2565 95.5262,11.9005 90.9292,15.3715"
            fill="#FFFFFF"
          />
          <path
            d="M90.9292,15.3715 C90.4982,15.6965 90.0842,16.0535 89.6912,16.4455 C89.2992,16.8385 88.9432,17.2535 88.6172,17.6845 C85.1462,22.2805 85.5022,28.8485 89.6912,33.0375 C93.8812,37.2265 100.4492,37.5835 105.0452,34.1115 C105.4762,33.7865 105.8912,33.4305 106.2832,33.0375 C106.6762,32.6445 107.0322,32.2305 107.3572,31.8005 C110.8282,27.2025 110.4722,20.6355 106.2832,16.4455 C102.0942,12.2565 95.5262,11.9005 90.9292,15.3715"
            fill="#FFFFFF"
          />
          <path
            d="M90.9189,15.3705 C90.4879,15.6955 90.0739,16.0525 89.6809,16.4445 C89.2889,16.8375 88.9329,17.2525 88.6069,17.6825 C85.1359,22.2795 85.4919,28.8475 89.6809,33.0365 C93.8699,37.2255 100.4379,37.5825 105.0349,34.1105 C105.4659,33.7855 105.8799,33.4295 106.2729,33.0365 C106.6659,32.6435 107.0219,32.2295 107.3469,31.7995 C110.8179,27.2015 110.4619,20.6345 106.2729,16.4445 C102.0839,12.2555 95.5159,11.8985 90.9189,15.3705 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M90.9189,15.3705 C90.4879,15.6955 90.0739,16.0525 89.6809,16.4445 C89.2889,16.8375 88.9329,17.2525 88.6069,17.6825 C85.1359,22.2795 85.4919,28.8475 89.6809,33.0365 C93.8699,37.2255 100.4379,37.5825 105.0349,34.1105 C105.4659,33.7855 105.8799,33.4295 106.2729,33.0365 C106.6659,32.6435 107.0219,32.2295 107.3469,31.7995 C110.8179,27.2015 110.4619,20.6345 106.2729,16.4445 C102.0839,12.2555 95.5159,11.8985 90.9189,15.3705 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.6152,17.6225 C92.2882,17.8695 91.9732,18.1405 91.6752,18.4385 C91.3772,18.7365 91.1062,19.0525 90.8592,19.3795 C88.2222,22.8705 88.4922,27.8605 91.6752,31.0425 C94.8572,34.2255 99.8462,34.4955 103.3392,31.8585 C103.6662,31.6115 103.9812,31.3415 104.2792,31.0425 C104.5772,30.7445 104.8472,30.4295 105.0942,30.1015 C107.7322,26.6105 107.4612,21.6215 104.2792,18.4385 C101.0962,15.2565 96.1072,14.9855 92.6152,17.6225 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.6152,17.6225 C92.2882,17.8695 91.9732,18.1405 91.6752,18.4385 C91.3772,18.7365 91.1062,19.0525 90.8592,19.3795 C88.2222,22.8705 88.4922,27.8605 91.6752,31.0425 C94.8572,34.2255 99.8462,34.4955 103.3392,31.8585 C103.6662,31.6115 103.9812,31.3415 104.2792,31.0425 C104.5772,30.7445 104.8472,30.4295 105.0942,30.1015 C107.7322,26.6105 107.4612,21.6215 104.2792,18.4385 C101.0962,15.2565 96.1072,14.9855 92.6152,17.6225 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#FE5E48"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="97.9771 18.7387 97.9771 24.7417 100.5941 27.1887"
          />
        </g>
      </g>
    </g>
  </svg>
);
